

<template>
  <div style="
    background-color:#39a9dc;
    position:absolute;
    top:0;bottom:0;right:0;left:0">
      <v-img style="height:100%;filter: brightness(40%);" :src="backimage" >
      </v-img>

      <v-layout xs12 row wrap class="content content-mobile"
        >
        <v-flex xs12 style="margin-bottom:3rem">
          <h1 style="color:#FAFAFA">ASSET-TRACKING PLATFORM</h1>
          <h2 style="color:#BDBDBD;">Dashboard and Device Management</h2>

        </v-flex> 
        <v-flex xs12>
          <v-layout xs12 row wrap id="section1" style="margin-bottom:5rem">

            <!-- Device registration -->
            
            <v-flex xs8 offset-xs2 style="padding:1rem">
              <v-card color="#002052" class="white--text splash-screen-item" style="height:100%">
                <v-layout align-center>
                  <v-flex xs5  class="purple lighten-4">
                    <v-icon large class="purple--text" style="">accessibility</v-icon>
                  </v-flex>
                  <v-flex xs7>
                    <v-card-title primary-title style="text-align:left">
                      <div>
                        <div class="title" style="margin-bottom:0.5rem">Login</div>
                        <div>Login with your ST.com account and start to track and monitor your devices!</div>
                      </div>
                    </v-card-title>
                  </v-flex>
                </v-layout>
                <v-divider light></v-divider>
                <v-card-actions class="pa-3">
                  <v-spacer></v-spacer>
                  <v-btn  color="purple" dark v-on:click="signIn()" >Go</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <!-- <v-layout align-left>
      <v-flex xs12 sm6 offset-sm3>
        <v-card style="margin-top:10%">
          <v-layout align-center>        
              <img
                src="@/assets/home/muletto.png"
                style="width:32%;margin:0;padding:0"
              />
            <v-flex xs8 style="padding:2rem">
              <v-layout align-center >
                  <v-flex style="margin-bottom:1rem">
                    <img style="width:10%;margin-left:1rem;;margin-right:1rem" src="@/assets/st-logo.png"/>
                  </v-flex>
              </v-layout>
              <v-layout style="margin-bottom:1rem;margin-left:1rem;text-align:left"  >
                <v-flex  >
                  <div class="body-2"> <v-icon small style="margin-bottom:0.1rem">login</v-icon> Dashboard login</div>
                  <div class="caption" style="text-align:left;">Login with your Google account and start to track and monitor your devices!</div>
                </v-flex>
              </v-layout>
              <v-layout>
              <v-flex  xs4 offset-xs7>   
              <v-btn color="white" v-on:click="signIn('google')">Login <img style="margin-left:0.5rem;width:5%;padding-bottom:0.1rem" src="@/assets/google.png"/></v-btn>
              </v-flex>
              <v-flex  xs4 offset-xs7>   
              <v-btn color="white" v-on:click="signIn('saml')">Login SAML2.0</v-btn>
              </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout> -->

    <inprogress  :dialog="operationInProcess" :message="operationInProcessMessage" ></inprogress>
    


  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import {FormPayload,Validator,FormStructField,Confirm} from '@/components/models/FormDialog'

  export default {
    name: 'SignIn',

    props:["backimage"],
    data:function(){
      return {
        alert:true,
        form:null,
        startAuth:false,
        showInProgressPanel:false
      }
    },
    computed: {
      ...mapState(
        {
            operationInProcess:'operationInProcess',
            operationInProcessMessage: 'operationInProcessMessage'
        }
      )
    },
    created:function(){
      this.buildForm(true)
      this.startAuth=true
    },

    methods:{
      async signIn(){
        await this.$store.dispatch('authentication/login', 'google')
      },
      buildForm:function(login){
        this.form = new FormPayload({
          title: (!login)?'Signup':'Login',
          block: true,
        });

        if(!login){
          this.form.setConfirm(new Confirm({
            field1: 'password',
            field2: 'confirm'
          }));
        }

        let field =  new FormStructField({
          name: 'groupName',
          label: 'Device group name',
          type: 'text',
          icon: 'person',
          hint: 'Name of your device group',
          meter: false
        });
        let validator = new Validator({
          regex: {value:'^([0-9A-Za-z]+)$'},
          required: true,
          min: 2,
          max: 20
        });
        field.setValidator(validator);

        this.form.addField(field);

        field =  new FormStructField({
          name: 'password',
          label: 'Password',
          type: 'password',
          icon: 'lock',
          hint: 'Password of your device group',
          meter: true
        });
        validator = new Validator({
          required: true,
          min: 6,
          max: 20,
          regex: {value:''}
        });
        field.setValidator(validator);

        this.form.addField(field);

        if(!login){
          field =  new FormStructField({
            name: 'confirm',
            label: 'Confirm Password',
            type: 'password',
            icon: 'lock',
            meter: false
          });
          validator = new Validator({
            required: true,
            min: 6,
            max: 20,
            regex: {value:''}
          });
          field.setValidator(validator);

          this.form.addField(field);
        }
      }
    }
  }
</script>
